export enum LocalStorageKey {
    DEVICE_ID = 'deviceId',
    LAST_CREATED_VIDEO_SLUG = 'lastCreatedVideoSlug',
    SLIDE_CHANGES = 'slideChanges',
    TABLE_COLUMNS = 'tableColumns'
}
